module.exports = __webpack_public_path__ + "static/img/dyxq.edf15667.png";